import { Component, OnInit } from '@angular/core';
import { Channel } from 'src/app/models/Channel';
import { ChannelService } from 'src/app/services/Channel/Channel.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from "ngx-toastr";
@Component({
    selector: 'app-formchannel',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss'],
    standalone: false
})
export class FormChannelComponent implements OnInit {
  public form = new Channel();
  constructor(private http:ChannelService, private _router: Router,private route: ActivatedRoute, private toastr: ToastrService) { 

  }

  ngOnInit(): void {
    var params = this.route.snapshot.queryParams; 
    if(params['ID'] != undefined)
    {
      this.Loader(params)
    }
  }

  public Loader(params :any){
    this.http.GetChannelbyID(params).subscribe(response=>{
      if(response != null)
      {
        this.form = response;
      }
    })
  }

  Submit():void{
     let value = this.required();
     if(!value)
     {
       return;
     }
    this.http.Submit(this.form).subscribe(response=>{
      this.toastr.success(response.Message,"Information");
      this._router.navigate(['menu/channel/list']);
    });
  }
 

  required() : boolean
  {
    let message = true;
    if(this.form.SubDomain == '')
    {
      this.toastr.error("Subdomain is mandatory","Error");
      message = false;
    }
    if(this.form.ClientIDGuid == '')
    {
      this.toastr.error("ClientID is mandatory","Error");
      message = false;
    }
    if(this.form.ClientSecretGuid == '')
    {
      this.toastr.error("Client Secret is mandatory","Error");
      message = false;
    }
    if(!this.isValidGuid(this.form.ClientSecretGuid))
    {
      this.toastr.error("Client Secret must be a valid GUID format","Error");
      message = false;
    }
    if(!this.isValidGuid(this.form.ClientIDGuid))
    {
      this.toastr.error("Client ID must be a valid GUID format","Error");
      message = false;
    }
    return message;
  }

  private isValidGuid(guid: string): boolean {
    if (!guid || guid.trim() === '') {
      return false;
    }
    
    // More flexible GUID regex that accepts any valid GUID format
    const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return guidRegex.test(guid.trim());
  }
 

}
